var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_11515_8334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M17.8348 7.84804L14.4568 11.2698C14.2521 11.4931 13.9056 11.5011 13.6852 11.2857L13.6694 11.2698L10.2915 7.84804C10.1261 7.68852 10.0789 7.44126 10.1655 7.23388C10.2521 7.01853 10.4568 6.88293 10.6852 6.88293H12.2127C11.6852 4.69749 9.64578 3.24584 7.44106 3.48513C4.96862 3.71643 3.14972 5.94176 3.37807 8.44624C3.59854 10.7912 5.54342 12.5858 7.86625 12.5778C8.82688 12.5778 9.76389 12.2668 10.5355 11.6845C10.756 11.5011 11.0867 11.517 11.2915 11.7164L12.8899 13.3356C13.1103 13.5589 13.1182 13.9178 12.8977 14.1412C12.8899 14.1491 12.882 14.1571 12.8663 14.1651C11.5513 15.2817 9.90563 15.9198 8.19696 15.9836C3.83476 16.1192 0.181216 12.6656 0.000113157 8.23886C-0.141619 3.83607 3.26783 0.151128 7.61429 -0.000417196C11.6379 -0.13601 15.1182 2.83109 15.6694 6.87496H17.4332C17.6615 6.87496 17.8663 7.01853 17.9529 7.2259C18.0474 7.43328 18.0001 7.68852 17.8269 7.84006L17.8348 7.84804Z",
    fill: "#10A8CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11515_8334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c7619ae30762e5454e96a4e0835150a8.svg";
export { ForwardRef as ReactComponent };